import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { CustomAutoComplete } from "../../../../../../components/input/CustomAutoComplete";
import { FormProvider, useFormContext } from "react-hook-form";
import { AddEmissionContext } from "../../../../../../contexts/AddEmissionContext";
import { GOOD_TYPE } from "../../../../../../constants";
import { common, input, overview } from "../../../../../../i18n";
import { NumericField } from "../../../../../../components/input/NumericField";

const AddOutsourcingTransport = () => {
  const { t } = useTranslation([common, overview, input], {
    nsMode: "fallback",
  });

  const stepTwoForm = useFormContext();

  const { isDisabledAuxInput } = AddEmissionContext();

  return (
    <FormProvider {...stepTwoForm}>
      <Grid item xs={12} md={6}>
        <NumericField
          size="small"
          name="amount"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          disabled
          label={t("input-amount-of-distance")}
          placeholder={t("to-be-calculated")}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <CustomAutoComplete
          name="aux1"
          required={!isDisabledAuxInput}
          label={t("Goods-Type")}
          info={t("Goods-Type-Description")}
          control={stepTwoForm.control}
          listMenuItem={GOOD_TYPE}
          placeholder={t("Select-Param", {
            param: t("Goods-Type"),
          })}
          rules={
            isDisabledAuxInput
              ? undefined
              : {
                  required: t("This-field-is-required", {
                    param: t("Goods-Type"),
                  }),
                }
          }
          defaultValue={null}
          disabled={isDisabledAuxInput}
        />
      </Grid>

      {isDisabledAuxInput}

      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux2"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          label={t("Distance-One-way-km")}
          placeholder={t("Distance-One-way-km")}
          fullWidth
          disabled={isDisabledAuxInput}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux3"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          label={t("Loading-tonne")}
          placeholder={t("Loading-tonne")}
          fullWidth
          disabled={isDisabledAuxInput}
        />
      </Grid>
    </FormProvider>
  );
};

export default AddOutsourcingTransport;
